"use client";
import "./advisor_risk_management.scss";

import { ReactElement } from "react";
import { Stack } from "@/elements/stack/stack";
import { Text } from "@/elements/text/text";
import { i18n } from "@/model/i18n";
import { Container } from "@/elements/container/container";
import { AdvisorRiskManagementSlider } from "./advisor_risk_management_slider";

export function AdvisorRiskManagement(): ReactElement {
  return (
    <section
      aria-label="advisor-risk-management"
      className="advisor-risk-management"
    >
      <Container>
        <Stack size={32} desktopSize={80}>
          <Stack size={32}>
            <Text
              htmlElement="h2"
              type="h2-xbold"
              color="neutral-on-surface"
              uppercase
            >
              {i18n.t("pages.advisor.risk_management_title")}
            </Text>
            <div className="advisor-risk-management__text">
              <Text
                htmlElement="p"
                type="sh1-regular"
                color="neutral-on-surface"
              >
                {i18n.t("pages.advisor.risk_management_desc")}
              </Text>
            </div>
          </Stack>
          <AdvisorRiskManagementSlider />
        </Stack>
      </Container>
    </section>
  );
}
